import { useMediaQuery, useTheme } from '@mui/material';
import type {
  MissionStepKind,
  MissionTargetZone,
} from '../../../../shared/onboarding/missionTypes';
import { MISSION_PANEL_WIDTH_PX } from '../../../../shared/onboarding/missionViewport';

export function useMissionPresentation(
  stepKind?: MissionStepKind,
  targetZone?: MissionTargetZone,
  forceCollapsed = false,
) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isCompactDesktop = useMediaQuery(theme.breakpoints.down('lg'));
  const collapseSheet =
    forceCollapsed ||
    (isMobile && (stepKind === 'form' || stepKind === 'confirm'));

  const useSheet =
    isMobile ||
    (isCompactDesktop &&
      (targetZone === 'header-action' || targetZone === 'form'));

  return {
    variant: useSheet ? ('sheet' as const) : ('dock' as const),
    collapseSheet,
    panelWidth: MISSION_PANEL_WIDTH_PX,
  };
}
